<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_iv"></a>ST. MARTIN’S PAPERBACKS TITLES<br/>BY LOUISA EDWARDS</p>
<p class="para"> </p>
<p class="center-para"><em>Can’t Stand the Heat</em></p>
<p class="para"> </p>
<p class="center-para"><em>On the Steamy Side</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheeditor.vue?15c4a32c